var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.91667,
    y: 4.41667,
    width: 10.1667,
    height: 8.66667,
    rx: 1.83333,
    stroke: "#545454",
    strokeWidth: 1.33333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 7.5V10.75",
    stroke: "#545454",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 3.75L6.75 3.75",
    stroke: "#545454",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.25V3.125",
    stroke: "#545454",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 7.75V8",
    stroke: "#545454",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 7.75V8",
    stroke: "#545454",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66667 9.5C8.66667 9.13181 8.36819 8.83333 8 8.83333C7.63181 8.83333 7.33333 9.13181 7.33333 9.5H8.66667ZM7.33333 9.75V10.4167H8.66667V9.75H7.33333ZM7.33333 9.5V9.75H8.66667V9.5H7.33333Z",
    fill: "#545454"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 7.5V10.75",
    stroke: "#545454",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBot);
export default __webpack_public_path__ + "static/media/icon_bot.4a62dfe19b4422fcab71af20f1d7e8da.svg";
export { ForwardRef as ReactComponent };